export const menuItemsVerf = [
    {
        id: 1,
        label: 'menuitems.dashboards.text',
        link: '/',
        icon: 'bx-home-circle',
    },
    {
        id: 5,
        label: 'Malware',
        icon: 'bx-tone',
        link: '/malware',
        // isUiElement: true,
        // subItems: [
        //     {
        //         id: 6,
        //         label: 'Malware Analysis Queue',
        //         link: '/malware',
        //         parentId: 5
        //     },
        //     {
        //         id: 7,
        //         label: 'Malware Data Raw',
        //         link: '/malware',
        //         parentId: 5
        //     },
        // ]
    },
    {
        id: 23,
        label: 'malware.manage-report-analysis',
        icon: 'bx-customize',
        link: '/malware/report-analysis',
    },
   
];